import React from 'react';
import { motion } from 'framer-motion';
export function CallToAction() {
  return <section className="max-w-2xl mx-auto px-4 py-12 mb-16 text-center" data-id="element-41">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="bg-white p-8 sm:p-12 border-2 border-burgundy/10 rounded-sm relative overflow-hidden" data-id="element-42">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-gold/20 via-gold to-gold/20" data-id="element-43"></div>

        <h2 className="font-serif text-2xl sm:text-3xl text-gray-900 mb-8" data-id="element-44">
          Descubre cómo reactivar la juventud de tu rostro desde casa
        </h2>

        <a href="https://go.hotmart.com/E101139832A?ap=2e42" target="_blank" rel="noopener noreferrer" onClick={() => {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'InitiateCheckout');
        }
      }} className="w-full sm:w-auto bg-burgundy hover:bg-burgundy-light text-white font-sans font-semibold text-sm sm:text-base py-4 px-8 rounded-sm transition-colors duration-300 shadow-lg shadow-burgundy/20 flex items-center justify-center gap-2 mx-auto group" data-id="element-45">
          QUIERO DESCUBRIR EL MÉTODO COMPLETO
          <span className="transform group-hover:translate-x-1 transition-transform duration-200" data-id="element-46">
            →
          </span>
        </a>

        <p className="font-sans text-xs text-gray-500 mt-6" data-id="element-47">
          Presentación gratuita en video. Sin compromiso.
        </p>
      </motion.div>
    </section>;
}